  // state
  const state = () => ({
    salesChannelGroup: [],
    filterManualOrder: [],
    filterMarketplace: [],
    checkListReady: {},
    carrierListReady: [],
    isModalGenTrackingCode: false,
    isModalModalPrintTiktok: false,
    isModalSendToFulfillment: false,
    isModalModalCombineTiktok: {},
    updateShipmentDataTable: 0,
    locationAll: [],
    locatoinBilling: {},
    shipmentDataList: [],
    isShipmentLoading: false,
    updateListReady: {},
    salesOrderData: {},
    logisticAccount: [],
    serviceAreaJson: [],
    slaSettingJson: null,
    remoteAreaJson: [],
    tourismJson: [],
    tableRateJson: [],
    defaultWrongAddress: {},
    isProgressBarUpdateShipment: false,
    dataUpdateShipment: [],
    isModalMoveToReadyToShip: false,
    isFulfillment: false,
    retryFulfillmentList: [],
    retryFulfillmentShipment: [],
    isModalSplitShipment: false,
    listDataSplitShipment : [],
    isModalUnSplitShipment: false,
    unSplitShipmentId: {},
    listDataPrint: {},
    dataIncomming:{},
    dataUpdated:{}
   // shipmentLoading: []
  });

  // getters
  const getters = {};

  // actions
  const actions = {
    salesChannelGroup({ commit }, data) {
      commit('setSalesChannelGroup', data);
    },
    filterManualOrder({ commit }, data) {
      commit('setFilterManualOrder', data);
    },
    filterMarketplace({ commit }, data) {
      commit('setFilterMarketplace', data);
    },
    checkListReady({ commit }, data) {
      commit('setDataCheckListReady', data);
    },
    checkListPrintTiktok({ commit }, data) {
      commit('setDataListPrintTiktok', data);
    },
    removeCheckListReady({ commit, state }, id) {
      let newCheckListReady = [];
      newCheckListReady['data'] = state.checkListReady.data.filter(function(e) { return e.integration_new.id !== id });
      commit('setDataCheckListReady', newCheckListReady);
    },
    removeShipmentInCheckListReady({ commit, state }, id) {
      let newDataShipmentInCheckListReady = [];
      newDataShipmentInCheckListReady['data'] = state.checkListReady.data.filter(function(e) { return e.id !== id });
      // state.updateListReady = newDataShipmentInCheckListReady;

      commit('updateListReady', newDataShipmentInCheckListReady);

      commit('setDataCheckListReady', newDataShipmentInCheckListReady);
    },
    isModalGenTrackingCode({ commit }, data) {
      commit('setModalGenTrackingCode', data);
    },
    isModalSendToFulfillment({ commit }, data) {
      commit('setModalSendToFulfillment', data);
    },
    isModalModalPrintTiktok({ commit }, data) {
      commit('setModalPrintTiktok', data);
    },
    isModalModalCombineTiktok({ commit }, data) {
      commit('setModalCombineTiktok', data);
    },
    setInProgressShipment({ commit }, payload) {
      commit('setInProgressShipment', payload);
    },
    moveShipmentDataTable({ commit }, payload) {
      commit('moveShipmentDataTable', payload);
    },
    updateShipmentDataTable({ commit }, data) {
      commit('updateShipmentDataTable', data);
    },
    locationAll({ commit }, data) {
      commit('setLocationAll', data);
    },
    shipmentDataList({ commit }, data) {
      commit('setShipmentDataList', data);
    },
    salesOrderData({ commit }, data) {
      commit('setSalesOrderData', data);
    },
    logisticAccount({ commit }, data) {
      commit('setlogisticAccount', data);
    },
    defaultWrongAddress({commit}, data) {
      commit('setDefaultWrongAddress', data);
    },
    serviceAreaJson({ commit, state }, payload) {
      let checkCode = state.serviceAreaJson.find(function(element) { return element.code == payload.code });
      if (payload.action == "get") {
        return checkCode ? checkCode.data : checkCode;
      } else if (payload.action == "add") {
        if (!checkCode) {
          commit('setServiceAreaJson', payload);
        }
      } else {
        commit('clearStateJsonData');
      }
    },
    remoteAreaJson({ commit, state }, payload) {
      let checkCode = state.remoteAreaJson.find(function(element) { return element.code == payload.code });
      if (payload.action == "get") {
        return checkCode ? checkCode.data : checkCode;
      } else {
        if (!checkCode) {
          commit('setRemoteAreaJson', payload);
        }
      }
    },
    tourismJson({ commit, state }, payload) {
      let checkCode = state.tourismJson.find(function(element) { return element.code == payload.code });
      if (payload.action == "get") {
        return checkCode ? checkCode.data : checkCode;
      } else {
        if (!checkCode) {
          commit('setTourismJson', payload);
        }
      }
    },
    tableRateJson({ commit, state }, payload) {
      let checkRateversionId = state.tableRateJson.find(function(element) { return element.rateVersionId == payload.rateVersionId });
      if (payload.action == "get") {
        return checkRateversionId ? checkRateversionId.data : checkRateversionId;
      } else {
        if (!checkRateversionId) {
          commit('setTableRateJson', payload);
        }
      }
    },
    slaSettingJson({ commit, state }, payload) {
      if (payload.action == "get") {
        return state.slaSettingJson;
      } else {
        commit('setSlaSettingJson', payload);
      }
    },
    isProgressBarUpdateShipment({ commit }, data) {
      commit('setProgressBarUpdateShipment', data);
    },
    dataUpdateShipment({ commit }, data) {
      commit('setDataUpdateShipment', data);
    },
    isModalMoveToReadyToShip({ commit }, data) {
      commit('setProgressBarMoveToReadyToShip', data);
    },
    setIsFulfillment({ commit }, data) {
      commit('setIsFulfillment', data);
    },
    setRetryFulfillmentList({ commit }, data) {
      commit('setRetryFulfillmentList', data);
    },
    setRetryFulfillmentShipment({ commit }, data) {
      commit('setRetryFulfillmentShipment', data)
    },
    isModalSplitShipment({ commit }, data) {
      commit('setModalSplitShipment', data);
    },
    listDataSplitShipment({ commit }, data) {
      commit('listDataSplitShipment', data);
    },
    isModalUnSplitShipment({ commit }, data) {
      commit('setModalUnSplitShipment', data);
    },
    unSplitShipmentId({ commit }, data) {
      commit('unSplitShipmentId', data);
    },
    listDataPrint({ commit }, data) {
      commit('listDataPrint', data);
    },
    dataIncomming({ commit }, data) {
      commit('dataIncomming', data);
    },
    dataUpdated({ commit }, data) {
      commit('dataUpdated', data);
    },
  };

  // mutations
  const mutations = {
    setSalesChannelGroup(state, data){
      state.salesChannelGroup = data;
    },
    setFilterManualOrder(state, data){
      state.filterManualOrder = data;
    },
    setFilterMarketplace(state, data){
      state.filterMarketplace = data;
    },
    setDataCheckListReady(state, data) {
      state.checkListReady = data;

      let shipmentList = [];
      let serviceFee = [];
      let usePromotion = [];

      const isMkp = data.data.some(({mkp = false}) => mkp);

      if(isMkp) return;

      data.data.forEach((value, index) => {

        if(!value.integration_new || !value.integration_new.id){
          value.integration_new = value.integration;
        }

          if(!shipmentList[value.integration_new.id]){
            shipmentList[value.integration_new.id] = [];
          }
          shipmentList[value.integration_new.id].push(value);

          if(value.dataEstimate){
            if(!serviceFee[value.integration_new.id]){
              serviceFee[value.integration_new.id] = 0;
            }

            if(value.dataEstimate.rate_calculate){
              serviceFee[value.integration_new.id] += value.dataEstimate.rate_calculate.total;

              if(value.dataEstimate.use_promotion){
                let i = 0;
                usePromotion[value.integration_new.id] = '';
                for (var key of Object.keys(value.dataEstimate.use_promotion)) {
                  if(i++ > 0){
                    usePromotion[value.integration_new.id] += ', ';
                  }

                  if(value.dataEstimate.use_promotion[key].name){
                    usePromotion[value.integration_new.id] += value.dataEstimate.use_promotion[key].name;
                  }
                }
              }
            }else{
              console.log(value.dataEstimate);
            }
          }

      });

      state.carrierListReady = [];
      shipmentList.forEach((value, index) => {
        let firstData = value[0];
        let salesTotal = value.reduce(function (acc, obj) { return acc + parseFloat(obj.total);}, 0);

        state.carrierListReady.push({
          id: index,
          name: firstData.integration_new.name,
          code: firstData.integration_new.code,
          detail: firstData.integration_new.description,
          logo: firstData.integration_new.logo,
          integration_data: firstData.integration_new.data,
          total: salesTotal,
          items_count: value.length,
          shipments: value,
          usePromotion: usePromotion[firstData.integration_new.id],
          service_fee: parseFloat(serviceFee[firstData.integration_new.id])
        });

      });
    },
    setDataListPrintTiktok(state, data){
       state.checkListPrintTiktok = data;
    },
    setModalGenTrackingCode(state, data) {
      let checkListReadyData = state.checkListReady.data;

      state.shipmentDataList['data'] = state.shipmentDataList['data'].map(function(shipmentlist){
        let itemIndex = checkListReadyData.findIndex(function(shipmentReady) {
          return shipmentReady.id == shipmentlist.id;
        });

        if(itemIndex != -1){
          return {...shipmentlist, loading: true};
        }

        return shipmentlist;
      });

      state.isShipmentLoading = !state.isShipmentLoading;
      state.isModalGenTrackingCode = data;
    },
    setModalSendToFulfillment(state, data) {
      state.isModalSendToFulfillment = data;
    },
    setModalPrintTiktok(state, data) {
      state.isModalModalPrintTiktok = data;
    },
    setModalCombineTiktok(state, data) {
      state.isModalModalCombineTiktok = data;
    },

    setInProgressShipment(state, payload) {
      let payloadStatus = payload.status;
      state.shipmentDataList['data'] = state.shipmentDataList['data'].map(function(shipmentlist){

        if(payload.shipmentIds.includes(shipmentlist.id)){
          shipmentlist = {...shipmentlist, loading: true};
        }

        if(payload.shipmentIds.includes(shipmentlist.id)){
         
          if (state.checkListReady.data) {
            const indexToRemove = state.checkListReady.data.findIndex(item => item.id === shipmentlist.id);

            if (indexToRemove !== -1) {
              state.checkListReady.data.splice(indexToRemove, 1);
            }
          }
          return {...shipmentlist, loading: payloadStatus};
        }

        return shipmentlist;
      });

      state.isShipmentLoading = !state.isShipmentLoading;
      // state.isProgressBarUpdateShipment = Number(state.isProgressBarUpdateShipment) + 1;
    },

    moveShipmentDataTable(state, payload) {
      const indexOfShipmentlist = state.shipmentDataList['data'].findIndex(shipmentlist => {
        return payload.shipmentIds.includes(shipmentlist.id);
      });
      const shipmentId = state.shipmentDataList['data'][indexOfShipmentlist].id;
      state.shipmentDataList['data'].splice(indexOfShipmentlist, 1);
      state.isShipmentLoading = !state.isShipmentLoading;
      return {
        'shipment_id' : shipmentId,
        'message' : 'done'
      }
    },

    updateShipmentDataTable(state, data) {
      state.shipmentDataList['data'] = state.shipmentDataList['data'].map(function(shipmentlist){
        shipmentlist['loading'] = false;
        return shipmentlist;
      });
      state.isShipmentLoading = !state.isShipmentLoading;
      state.updateShipmentDataTable++;
    },

    setLocationAll(state, data) {
      let locatoions = data.data.data;
      state.setLocationAll = locatoions;
      state.locatoinBilling = locatoions.find((locatoin) => {
        if(locatoin.location_defaults){
          return locatoin.location_defaults.find((location_default) => {
            return location_default.location_type.name == "billing";
          });
        }
      });
    },

    setShipmentDataList(state, data) {
      if (state.checkListReady.data) {
        let checkListReadyData = state.checkListReady.data;
        data.data = data.data.map(function(shipmentlist){
          let itemIndex = checkListReadyData.findIndex(function(shipmentReady) {
            return shipmentReady.id == shipmentlist.id;
          });

          if(itemIndex != -1){
            return {...shipmentlist, loading: true};
          }

          return shipmentlist;
        });
      }
      state.shipmentDataList = data;
    },

    updateListReady(state, data) {
      state.updateListReady = data;
    },

    setSalesOrderData(state, data) {
      state.salesOrderData = data;
    },
    setlogisticAccount(state, data) {
      state.logisticAccount = data;
    },
    setDefaultWrongAddress(state, data) {
      state.defaultWrongAddress = data;
    },
    clearStateJsonData(state) {
      state.logisticAccount = [];
      state.serviceAreaJson = [];
      state.remoteAreaJson = [];
      state.tourismJson = [];
      state.tableRateJson = [];
      // state.slaSettingJson = {};
    },
    setServiceAreaJson(state, payload) {
      state.serviceAreaJson.push({ code: payload.code, data: payload.data })
    },
    setRemoteAreaJson(state, payload) {
      state.remoteAreaJson.push({ code: payload.code, data: payload.data })
    },
    setTourismJson(state, payload) {
      state.tourismJson.push({ code: payload.code, data: payload.data })
    },
    setTableRateJson(state, payload) {
      state.tableRateJson.push({ rateVersionId: payload.rateVersionId, data: payload.data })
    },
    setSlaSettingJson(state, payload) {
      state.slaSettingJson = payload.data;
    },
    setProgressBarUpdateShipment(state, data) {
      state.isProgressBarUpdateShipment = data;
    },
    setDataUpdateShipment(state, data) {
      state.dataUpdateShipment = data;
    },
    setProgressBarMoveToReadyToShip(state, data) {
      state.isModalMoveToReadyToShip = data;
    },
    setIsFulfillment(state, data) {
      state.isFulfillment = data;
    },
    setRetryFulfillmentList(state, data) {
      state.retryFulfillmentList = data;
    },
    setRetryFulfillmentShipment(state, data) {
      state.retryFulfillmentShipment = data
    },
    setModalSplitShipment(state, data) {
      state.isModalSplitShipment = data;
    },
    listDataSplitShipment(state, data) {
      state.listDataSplitShipment = data;
    },
    setModalUnSplitShipment(state, data) {
      state.isModalUnSplitShipment = data;
    },
    unSplitShipmentId(state, data) {
      state.unSplitShipmentId = data;
    },
    listDataPrint(state, data) {
      state.listDataPrint = data;
    },
    dataIncomming(state, data) {
      state.dataIncomming = data;
    },
    dataUpdated(state, data) {
      state.dataUpdated = data;
    },
  };

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };



// WEBPACK FOOTER //
// ./src/store/modules/shipment.js